<template>
    <DnButton
        class="base-button"
        v-bind="$attrs"
    >
        <slot />
    </DnButton>
</template>

<script setup>
import DnButton from '@digitalnatives/button';
</script>

<style src="./BaseButton.less" lang="less"></style>
